import firebase from "firebase";
// import "firebase/firestore";
// import "firebase/database";
// import "firebase/auth";
// import "firebase/storage";

firebase.initializeApp({
  apiKey: "AIzaSyANeJ1J5OKyro4uksfreeYGervKZCEqwEY",
  authDomain: "app-servicos-3a220.firebaseapp.com",
  projectId: "app-servicos-3a220",
  storageBucket: "app-servicos-3a220.appspot.com",
  messagingSenderId: "747970079287",
  appId: "1:747970079287:web:6094832fa7d00f38b22db2",
  measurementId: "G-6QQYHQ8R4Y",
});

// firebase.initializeApp(config);
firebase.analytics();

export default firebase;
